import React from 'react'

import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Progress } from '../../../Progress'
import type { MessageStyles } from '../../messageBridge'

import { holdTimer } from './utils'

interface MessageContentProps {
  styles: MessageStyles
  title: React.ReactNode
  description?: React.ReactNode
  progress?: number
  closable: boolean
  closeLabel: string
  small: boolean
  role: 'alert' | 'status'
  onClose: () => void
  holdOnFocus: boolean
}

export const MessageContent: React.FC<MessageContentProps> = ({
  styles,
  title,
  description,
  progress,
  closable,
  closeLabel,
  small,
  role,
  onClose,
  holdOnFocus
}) => (
  <span
    className={[styles.body, small ? styles.bodySmall : '']
      .filter(Boolean)
      .join(' ')}
    role={role}
  >
    <span className={styles.text}>
      <span
        className={[styles.title, small ? styles.titleSmall : '']
          .filter(Boolean)
          .join(' ')}
      >
        {title}
      </span>
      {description != null && (
        <span
          className={[styles.description, small ? styles.descriptionSmall : '']
            .filter(Boolean)
            .join(' ')}
        >
          {description}
        </span>
      )}
      {progress != null && (
        <Progress
          variant="bar"
          size="small"
          showIcon={false}
          percent={progress}
        />
      )}
    </span>
    {closable && (
      <button
        type="button"
        className={styles.close}
        aria-label={closeLabel}
        onClick={onClose}
        onFocus={
          holdOnFocus
            ? (event) => holdTimer(event.currentTarget, true)
            : undefined
        }
        onBlur={
          holdOnFocus
            ? (event) => holdTimer(event.currentTarget, false)
            : undefined
        }
      >
        <FontAwesomeIcon icon={faXmark} aria-hidden />
      </button>
    )}
  </span>
)
